import React from 'react';
import { Link } from 'react-router-dom';

export default function Privacy() {
  return (
    <div className="max-w-4xl mx-auto py-8 px-4">
      <div className="bg-white rounded-lg shadow-md p-8">
        <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>
        <div className="prose prose-indigo max-w-none">
          <p className="text-sm text-gray-600 mb-6">Last Updated: January 20, 2024</p>
          
          <p className="mb-6">At StoryMuse.io, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our platform.</p>

          <h2 className="text-xl font-bold mt-8 mb-4">1. Information We Collect</h2>
          
          <h3 className="text-lg font-semibold mt-6 mb-2">1.1 Information You Provide</h3>
          <ul className="list-disc pl-6 mb-4">
            <li>Account information (email, username, password)</li>
            <li>Profile information (name, bio, avatar)</li>
            <li>Content you create (book ideas, comments, polls)</li>
            <li>Communications with other users</li>
          </ul>

          <h3 className="text-lg font-semibold mt-6 mb-2">1.2 Automatically Collected Information</h3>
          <ul className="list-disc pl-6 mb-4">
            <li>Device information</li>
            <li>Usage data</li>
            <li>IP address</li>
            <li>Browser type</li>
          </ul>

          <h2 className="text-xl font-bold mt-8 mb-4">2. How We Use Your Information</h2>
          <p className="mb-4">We use the collected information to:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Provide and maintain our services</li>
            <li>Improve user experience</li>
            <li>Send notifications and updates</li>
            <li>Respond to your requests</li>
            <li>Prevent fraud and abuse</li>
          </ul>

          <h2 className="text-xl font-bold mt-8 mb-4">3. Information Sharing</h2>
          <p className="mb-4">We do not sell your personal information. We may share your information with:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Service providers who assist in platform operations</li>
            <li>Legal authorities when required by law</li>
            <li>Other users (only information you choose to make public)</li>
          </ul>

          <h2 className="text-xl font-bold mt-8 mb-4">4. Data Security</h2>
          <p className="mb-4">We implement appropriate security measures to protect your information, including:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Encryption of sensitive data</li>
            <li>Regular security assessments</li>
            <li>Access controls and authentication</li>
            <li>Secure data storage</li>
          </ul>

          <h2 className="text-xl font-bold mt-8 mb-4">5. Your Rights</h2>
          <p className="mb-4">You have the right to:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Access your personal information</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Opt-out of marketing communications</li>
            <li>Export your data</li>
          </ul>

          <h2 className="text-xl font-bold mt-8 mb-4">6. Cookies and Tracking</h2>
          <p className="mb-4">We use cookies and similar technologies to:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Remember your preferences</li>
            <li>Analyze platform usage</li>
            <li>Improve our services</li>
            <li>Provide personalized content</li>
          </ul>

          <h2 className="text-xl font-bold mt-8 mb-4">7. Children's Privacy</h2>
          <p className="mb-4">Our platform is not intended for children under 13. We do not knowingly collect information from children under 13.</p>

          <h2 className="text-xl font-bold mt-8 mb-4">8. Changes to Privacy Policy</h2>
          <p className="mb-4">We may update this Privacy Policy periodically. We will notify you of significant changes via email or platform notifications.</p>

          <h2 className="text-xl font-bold mt-8 mb-4">Contact Information</h2>
          <p className="mb-4">For questions about this Privacy Policy, please contact us at:</p>
          <p className="mb-4">Email: privacy@storymuse.io</p>

          <div className="mt-8 text-sm text-gray-600">
            <p>See also our{' '}
              <Link to="/terms" className="text-indigo-600 hover:text-indigo-800">
                Terms of Service
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}